"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _MenuHistoryHolder = require("../api/MenuHistoryHolder");
var _PageSecurity = require("../api/authz/PageSecurity");
var _ThemeUtils = require("../api/theme/ThemeUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class PageHitLogger extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "goBack", () => {
      const {
        history
      } = this.props;
      history.goBack();
    });
    this.state = {
      user: undefined,
      isLoading: true,
      isAllowed: false
    };
  }
  componentDidMount() {
    const {
      match,
      history,
      menuItem
    } = this.props;
    const {
      location
    } = history;
    const {
      path
    } = match;
    _SecurityContextHolder.SecurityContextHolder.generateRouteUUID();
    const routePath = path === '/' ? '/home.html' : path;
    let referrerPathname = '/';
    const menuHistory = _MenuHistoryHolder.MenuHistoryHolder.getHistory();
    if (menuHistory && menuHistory.length > 1) {
      referrerPathname = menuHistory[menuHistory.length - 1].pathname;
    }

    /**
     * The following code will check the Security Manager to determine if the page is allowed.
     * It is important to note that this content might not be reached as there will not be a
     * REACT component defined for the particular URL being requested (these would have
     * typically resulted in the 403 response below).
     *
     */
    // Check that the page is allowed.
    (0, _PageSecurity.logPageHit)(routePath, referrerPathname).then(() => {
      _MenuHistoryHolder.MenuHistoryHolder.addHistory(location, menuItem);
    });
    (0, _ThemeUtils.applyTheme)(menuItem.theme);
  }
  render() {
    return this.props.children;
  }
}
exports.default = PageHitLogger;
PageHitLogger.propTypes = {
  menuItem: _propTypes.default.shape({
    theme: _propTypes.default.string
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    goBack: _propTypes.default.func.isRequired,
    listen: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string.isRequired
    })
  }),
  match: _propTypes.default.shape({
    path: _propTypes.default.string
  }),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
//# sourceMappingURL=PageHitLogger.js.map